import Typography from '@mui/material/Typography';
//import Grid from '@mui/material/Grid';
//import TextCenter from "../../../components/TextComps/TextCenter";



export default function ClockText() {
  
  return (
<div>
    
    <Typography variant="body" >
    
    
     <br /><br />
    
    
    <Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Epigenetic Clocks </Typography>
    <br /><br />
    
    <br /><br />
    <Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Proteomics-based Clocks </Typography>
    <br /><br />
<br /><br />
    Source: MedlinePlus, https://medlineplus.gov/genetics/condition/breast-cancer/
    </Typography>
    
    </div>

   )
}